@if (hasNameDisplay) {
  <div
    class="text-container"
    [ngClass]="bgColorClass"
    [matTooltip]="displayName()">
    <span [ngClass]="colorClass">{{ getInitials }}</span>
  </div>
} @else {
  <div
    [matTooltip]="displayName() | tasksUnassignedDescription"
    class="text-container border-avatar-preview bg-white">
    <span class="text-slate-200">- -</span>
  </div>
}
